__webpack_require__.p = "/guidelines_pages.github.io/";